import restaurantModalLoginInstance from '../../modalLoginInstance'
import restaurantInstance from '../../instance'

const deleteTableSplit = (splitId, tableId, hasModalLogin = true, data) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .delete(`/tables/${tableId}/splits/${splitId}`, { data })
}

export default deleteTableSplit
